module.exports = __webpack_public_path__ + "img/RickyAvicenna-nologo.9f68a7c0.png";